<template>
    <div class="drawer-perfil">

        <!-- Dialog cargar sellos -->
        <q-dialog v-model="dialogSubirArchivos" persistent transition-show="flip-down" transition-hide="flip-up">
            <q-card style="min-width:360px;border-radius:16px">
                <q-card-section style="background:#662e91;border-radius:16px 16px 0 0">
                    <div class="row justify-between items-center">
                        <div class="text-h6 text-white">Cargar Archivo</div>
                        <q-btn flat round dense icon="mdi-close" class="text-white" @click="inicializar()" />
                    </div>
                </q-card-section>
                <template v-if="GuardandoSellos">
                    <q-card-section>
                        <div class="text-center q-py-xl">
                            <q-spinner-cube color="deep-purple" size="5.5em" />
                        </div>
                    </q-card-section>
                </template>
                <template v-else>
                    <q-card-section class="q-pa-md">
                        <q-select filled v-model="archivo.tipo" :options="['FIEL', 'CSD']" label="Tipo de Archivo"
                            class="q-mb-md" />
                        <div class="upload-label">Archivo .key</div>
                        <q-input filled type="file" accept=".key" @input="uploadKey" class="q-mb-md" />
                        <div class="upload-label">Archivo .cer</div>
                        <q-input filled type="file" accept=".cer" @input="uploadCer" class="q-mb-md" />
                        <q-input filled :label="$t('app.password')" v-model="archivo.password"
                            :type="isPwd ? 'password' : 'text'">
                            <template v-slot:append>
                                <q-icon :name="isPwd ? 'visibility_off' : 'visibility'" class="cursor-pointer"
                                    @click="isPwd = !isPwd" />
                            </template>
                        </q-input>
                    </q-card-section>
                    <q-card-actions class="q-px-md q-pb-md">
                        <q-btn unelevated color="deep-purple" class="full-width" :label="$t('buttons.save')"
                            style="border-radius:10px" @click="validarArchivos()" />
                    </q-card-actions>
                </template>
            </q-card>
        </q-dialog>

        <!-- Banner perfil -->
        <div class="profile-banner">
            <div class="profile-avatar">{{ iniciales }}</div>
            <div class="profile-name">{{ token.nombre }}</div>
            <div class="profile-rfc">{{ token.rfc }}</div>
            <div class="profile-empresa">{{ token.empresa }}</div>
        </div>

        <!-- Certificados -->
        <div class="cert-section">
            <div class="section-label">Certificados</div>
            <div class="cert-item" v-for="a in archivos" :key="a.tipo">
                <div class="cert-dot" :style="{ background: dotColor(a.color) }"></div>
                <div class="cert-info">
                    <div class="cert-tipo">{{ a.tipo }}</div>
                    <div class="cert-fecha">{{ formatDate(a.fechaVigencia) }}</div>
                </div>
                <q-icon :name="a.icono" :color="a.iconoColor" size="16px">
                    <q-tooltip>{{ a.estatus }}</q-tooltip>
                </q-icon>
            </div>
        </div>

        <!-- Menú -->
        <q-list class="menu-list">

            <q-item clickable v-ripple class="menu-item" @click="abriDialog()">
                <q-item-section avatar><q-icon name="mdi-upload" size="20px" color="grey-6" /></q-item-section>
                <q-item-section>{{ $t('drawer.uploadSeals') }}</q-item-section>
            </q-item>

            <q-item clickable v-ripple class="menu-item" @click="irConfiguracion()">
                <q-item-section avatar><q-icon name="mdi-cog" size="20px" color="grey-6" /></q-item-section>
                <q-item-section>{{ $t('drawer.settings') }}</q-item-section>
            </q-item>

            <q-separator class="q-my-xs" />

            <!-- Idioma -->
            <q-item tag="label" v-ripple class="menu-item">
                <q-item-section avatar><q-icon name="mdi-translate" size="20px" color="grey-6" /></q-item-section>
                <q-item-section>{{ $t('app.language') }}</q-item-section>
                <q-item-section side style="min-width: 180px">
                    <q-select dense outlined hide-dropdown-icon :options="langOptions" v-model="selectedLocale"
                        emit-value map-options />
                </q-item-section>
            </q-item>

            <q-separator class="q-my-xs" />

            <!-- Modo oscuro -->
            <!-- <q-item tag="label" v-ripple class="menu-item">
                <q-item-section avatar><q-icon name="mdi-weather-night" size="20px" color="grey-6" /></q-item-section>
                <q-item-section>{{ $t('drawer.darkMode') }}</q-item-section>
                <q-item-section side>
                    <q-toggle color="deep-purple" :value="modoOscuro" v-model="isDarkMode" val="battery" />
                </q-item-section>
            </q-item> -->


            <q-item clickable v-ripple class="menu-item menu-danger" @click="salir()">
                <q-item-section>{{ $t('drawer.logout') }}</q-item-section>
                <q-item-section avatar><q-icon name="mdi-logout" size="20px" color="deep-purple-7" /></q-item-section>
            </q-item>

        </q-list>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { localeList, setLanguage } from '../../i18n'

export default {
    data() {
        return {
            isPwd: false,
            isDarkMode: false,
            dialogSubirArchivos: false,
            GuardandoSellos: false,
            selectedLocale: this.$i18n ? this.$i18n.locale : 'es'
        }
    },

    watch: {
        isDarkMode(val) {
            this.$store.state.modoOscuro = val
            this.$q.dark.set(val)
        },
        selectedLocale(newLocale) {
            setLanguage(newLocale)
            this.$q.notify({
                type: 'info',
                message: this.$t('app.languageChanged'),
                caption: this.$t('app.reloadRequired'),
                actions: [{
                    label: this.$t('buttons.reload'),
                    color: 'white',
                    handler: () => window.location.reload()
                }]
            })
        }
    },

    computed: {
        token() { return this.$store.state.usuario },
        modoOscuro() { return this.$store.state.modoOscuro },
        langOptions() { return localeList },
        archivos() { return this.$store.state.listaArchivosVigenciaStore },
        archivo() { return this.$store.state.archivosStore },
        rutaDescargas() { return this.$store.state.rutaDescargas },
        iniciales() {
            return this.token.nombre
                .split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase()
        }
    },

    created() {
        this.GetVigenciaArchivos()
    },

    methods: {
        dotColor(c) {
            return { green: '#69d46e', orange: '#ffd166', red: '#ff8080' }[c] || '#ccc'
        },

        abriDialog() { this.dialogSubirArchivos = true },
        irConfiguracion() { this.$router.push('Configuracion') },

        async validarArchivos() {
            if (!this.archivo.tipo) {
                this.$q.notify({ type: 'negative', message: 'Seleccione el tipo de archivo que desea subir.', color: 'red' })
                return
            }
            this.GuardandoSellos = true
            try {
                let response = await axios.post(
                    this.rutaDescargas + 'Validacion/PostValidarArchivos/erp_' + this.token.rfc + '/' + this.token.rfc,
                    this.archivo
                )
                console.log(response.data)
                this.$q.notify({ type: 'positive', message: 'Archivo guardado exitosamente.' })
                this.GetVigenciaArchivos()
                this.inicializar()
            } catch (error) {
                console.log(error)
                this.$q.notify({ type: 'negative', message: error.response.data })
            } finally {
                this.GuardandoSellos = false
            }
        },

        async GetVigenciaArchivos() {
            this.$store.state.listaArchivosVigenciaStore = []
            try {
                let response = await axios.get(this.rutaDescargas + 'Validacion/GetVigenciaArchivos/erp_' + this.token.rfc)
                this.$store.state.listaArchivosVigenciaStore = response.data
            } catch (error) {
                console.log(error)
            }
        },

        async salir() {
            this.$store.state.regimenFiscalStore = []
            this.$store.state.listaHistorialDescargasMetadataStore = []
            this.$store.state.listaHistorialDescargasCFDIStore = []
            this.$store.state.listaHistorialDescargasUUIDStore = []
            this.$store.state.listaArchivosVigenciaStore = []
            this.$store.state.listaCatalogoCuentasStore = []
            this.$store.state.listaCatalogoCuentasSatStore = []
            this.$store.state.listaPolizasStore = []
            this.$store.state.listaConcilarPolizasStore = []
            this.$store.state.listDiotStore = []
            this.$store.state.empresaStore = {
                _id: '', rfc: '', nombre: '',
                regimenFiscal: { regimenFiscal: '' },
                domicilioFiscal: '',
                logo: { base64: '' },
                nombreCorreo: '', correo: '', password: '', puerto: '', host: ''
            }
            this.$q.loading.show({ message: '<b>Cerrando Sesión...</b>' })
            this.$store.dispatch('salir')
            this.$q.loading.hide()
        },

        inicializar() {
            this.dialogSubirArchivos = false
            this.$store.state.archivosStore = {
                tipo: '', nombreCer: '', archivoCer: { base64: '' },
                nombreKey: '', archivoKey: { base64: '' }, password: ''
            }
        },

        async uploadKey(event) {
            const file = event[0]
            try {
                this.$store.state.archivosStore.archivoKey.base64 = await this.convertBase64(file)
                this.$store.state.archivosStore.nombreKey = file.name
            } catch (e) { console.error(e) }
        },

        async uploadCer(event) {
            const file = event[0]
            try {
                this.$store.state.archivosStore.archivoCer.base64 = await this.convertBase64(file)
                this.$store.state.archivosStore.nombreCer = file.name
            } catch (e) { console.error(e) }
        },

        convertBase64(file) {
            return new Promise((resolve, reject) => {
                const r = new FileReader()
                r.readAsDataURL(file)
                r.onload = () => resolve(r.result)
                r.onerror = () => reject(r.error)
            })
        },

        formatDate(value) {
            const d = new Date(value.replace('T', ' ').replace('Z', ' '))
            moment.locale('es-mx')
            return moment(d).format('YYYY-MM-DD HH:mm:ss')
        }
    }
}
</script>

<style scoped>
.drawer-perfil {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #fff;
}

.profile-banner {
    background: #662e91;
    padding: 24px 20px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.profile-avatar {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: rgba(255, 255, 255, .2);
    border: 2px solid rgba(255, 255, 255, .35);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: 600;
    color: #fff;
}

.profile-name {
    font-size: 17px;
    font-weight: 600;
    color: #fff;
    text-align: center;
}

.profile-rfc {
    font-size: 16px;
    color: rgba(255, 255, 255, .7);
}

.profile-empresa {
    font-size: 14px;
    color: rgba(255, 255, 255, .5);
}

.cert-section {
    padding: 14px 20px;
    border-bottom: 0.5px solid #f0f0f0;
}

.section-label {
    font-size: 12px;
    color: #aaa;
    text-transform: uppercase;
    letter-spacing: .07em;
    font-weight: 600;
    margin-bottom: 10px;
}

.cert-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 7px 0;
    border-bottom: 0.5px solid #f5f5f5;
}

.cert-item:last-child {
    border-bottom: none;
}

.cert-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}

.cert-info {
    flex: 1;
}

.cert-tipo {
    font-size: 15px;
    font-weight: 600;
    color: #111;
}

.cert-fecha {
    font-size: 13px;
    color: #aaa;
}

.menu-list {
    flex: 1;
}

.menu-item {
    min-height: 44px !important;
    font-size: 15px;
    color: #333;
}

.menu-danger {
    color: #662e91 !important;
}

.upload-label {
    font-size: 11px;
    color: #888;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: .05em;
    font-weight: 600;
}
</style>